import ReportTable from './ReportsTable';
import React, {useState} from 'react';
import {Text} from '@forecast-it/design-system';
import {ReportRow} from './ReportTypes';
import type {ReportsPage_viewer} from './__generated__/ReportsPage_viewer.graphql';

type ReportTabContentProps = {
	enableSelection: boolean;
	company: ReportsPage_viewer['company'];
	reports: ReportRow[];
	search: string;
	groupings: string[];
	scrollRef: React.MutableRefObject<null>;
	groupingColumnHeader: string;
};

const ReportsTabContent = ({
	enableSelection,
	company,
	reports,
	search,
	groupings,
	scrollRef,
	groupingColumnHeader,
}: ReportTabContentProps): React.JSX.Element => {
	const [filteredReports, setFilteredReports] = useState<ReportRow[]>([]);

	const showFilterText = filteredReports.length !== reports.length;
	const filterText = `Showing (${filteredReports.length} of ${reports.length})`;

	return (
		<>
			<Text size={'2'}> {showFilterText ? filterText : ''}</Text>
			<ReportTable
				enableSelection={enableSelection}
				company={company}
				reports={reports}
				search={search}
				groupings={groupings}
				scrollRef={scrollRef}
				setFilteredRows={setFilteredReports}
				groupingColumnHeader={groupingColumnHeader}
			/>
		</>
	);
};

export default ReportsTabContent;
